import { Component } from '@angular/core';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-mvp-membership-banner',
  templateUrl: './mvp-membership-banner.component.html',
  styleUrls: ['./mvp-membership-banner.component.scss'],
})
export class MvpMembershipBannerComponent {
  productCode = ProductCode;
}
